var React = require('react');

function TickedBoxActiveInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M2.57143 24H21.4286C22.8488 24 24 22.8488 24 21.4286V2.57143C24 1.15125 22.8488 0 21.4286 0H2.57143C1.15125 0 0 1.15125 0 2.57143V21.4286C0 22.8488 1.15125 24 2.57143 24Z","fill":"currentColor","key":0}),React.createElement("path",{"d":"M5.25 11.25L10.5 16.5L18.75 8.25","stroke":"#F4F1EE","strokeWidth":"2","strokeLinejoin":"round","key":1})]);
}

TickedBoxActiveInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = TickedBoxActiveInline;

TickedBoxActiveInline.default = TickedBoxActiveInline;
